import { type FeatureModule } from '@store/features/types';

/**
 * Thumbs Feedback feature module definition
 * No Redux slice — all widget state is local. Uses useSubmitCSATMutation from the feedback feature.
 */
export const thumbsFeedbackFeature: FeatureModule = {
  id: 'thumbs-feedback',
  name: 'Thumbs Feedback',
  reducers: {},
  middleware: [],
};
